import React from 'react';

import { Card, Grid } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { AutocompleteField, InputSearch } from 'common/components';

import { getBrandOptions } from '../helpers';

const BulkOperationsCard = ({
    disabled,
    brands,
    filterData,
    handleOnChangeBrand,
    handleOnChangeSearch,
    isFetchingBrands,
}) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Grid alignItems="end" container justifyContent="flex-end">
                    <Grid size={{ lg: 14, md: 12, xs: 18 }}>
                        <InputSearch
                            disabled={disabled}
                            onChange={handleOnChangeSearch}
                            placeholder={t('Search')}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid size={{ lg: 4, md: 6, xs: 18 }}>
                        <AutocompleteField
                            disabled={isFetchingBrands || disabled}
                            label={
                                isEmpty(filterData?.brand)
                                    ? t('All brands')
                                    : t('Brand')
                            }
                            onChange={handleOnChangeBrand}
                            options={getBrandOptions(brands)}
                            value={filterData?.brand}
                        />
                    </Grid>
                </Grid>
            </Card.Body>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    disabled: PropTypes.bool,
    brands: PropTypes.array,
    filterData: PropTypes.object,
    handleOnChangeBrand: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    isFetchingBrands: PropTypes.bool,
};

export default BulkOperationsCard;
